// extracted by mini-css-extract-plugin
export default {"provider-search__fpo-img":"zCX2mA","provider-search__header":"umukZX"};